export const environment = {
  "production":true,
  "baseUrl":"https://us.allcaresoftware.com/",
"uiVersion":"4.0.1",
  "hosturl":"https://us.allcaresoftware.com/",
  "ADP_PayrollReport":"79ec120c-a882-4cd4-ad5e-1d4d7e1b94c8",
  "AgingDateReportId":"d805f778-925b-4bce-bbf7-eb567d80695e",
  "AgingReportwithDateReportId":"277cfda6-be9f-477f-8cb5-81bf806456af",
  "AgingReportwithoutDateReportId":"6781aeca-31b8-45c3-86a2-8310575ab68d",
  "BatchCreateReportId":"3349761f-9dde-42d2-82d0-60ce8a56f98f",
  "BatchViewReportId":"9a834d7a-f92c-4ee6-9b21-43b6768189bf",
  "BilledClientReportId":"f0435e7e-77e9-4329-8736-84494fbad520",
  "CheckEFT":"e99d7c85-de2f-4c18-b8cd-1ad7d6733791",
  "ClaimVsPaid":"f1b694e6-7f25-49a3-af34-57b249d07f4e", 
  "ClientBirthDayReportId":"042f7673-d0e1-49a6-b2d6-34d3253812a6",
  "ClientHoursSummaryReportId":"593bb3d5-cd69-47ac-aba6-eddef4972e7c",
  "ClientLabels":"a1c1d139-c456-4c75-bdcc-f6adec80fdcb",
  "Client_EmployeeNotesId":"7b943c08-a999-49b6-8923-759f434ce507",
  "ComingDueAuthorizationChartReportId":"b65faf50-2e1d-47e1-a852-c6b43ec73ccf",
  "ComingDueAuthorizationReportId":"c765bcfc-759e-4f56-a84f-c9d4b43bc1db",
  "EmployeeBirthDayReportId":"6838a753-02b7-4fca-86e2-4a55f2ac9d72",
  "EmployeeHoursSummaryReportId":"566430c4-1183-44d6-b41c-24061d15f854",
  "EmployeePayRateReportId":"663ab729-d734-4f36-a92a-42d402dec642",
  "EmployeePayorIdListReportId":"d3753c99-d243-427e-874c-a1537dc0fa02",
  "EndOfYearReport":"5ed01ab2-6216-4a88-bd2a-3aca96affc83",
  "HousingCaseReportId":"c0dd4159-1454-4e6d-92a4-ec8c88c00c7b",
  "HousingTimesheetReportId":"0004e01f-1f20-446e-a429-bb92163bf815",
  "LastDateofServiceReportId":"640f5e5f-7058-47ea-891a-442c015b22e3",
  "LiveInReportId":"c83e6bde-cace-49db-86e2-4a0b5408fef2",
  "MissingTimesheetReportId":"981d66d4-4400-4834-b4b7-5a43695080fe",
  "OpenInvoiceReportId":"f99239f5-d91e-48aa-a76e-9e65d63523e1",
  "PaidPayrollNotBilledReportDetails":"f8a928d1-e7f2-498b-8060-baa12b6fece3",

  "PaidPayrollNotBilledReportSummary":"9c9538e7-4d4a-451f-9e44-1e032ae71ae9",
  "PayrollExcelReportId":"fafaf157-f46d-49f4-b9a8-f18179b04953",
  "PayrollReportId":"36020e01-1b72-4177-a9b1-fd9116a18572",
  "PowerBIWorkSpace":"c4cac6c7-e0cc-4f58-837b-0ec04facded2",
  "PrivatePayMileageLogReportId":"c14e4e01-1702-4d64-976a-578c35c42a4c",
  "QpEmployeeReportId":"17cf0e77-1eb9-4a17-ab5e-03f064569c85",
  "QpInfoReportId":"101b4326-b6b6-481c-9812-17f27605ff8c",
  "RPReportId":"2e6e4a22-596b-41aa-96b3-e216fa41aadf",
  "SpendDown":"b7f9336b-54c2-4bda-8462-d2c32e36ccef",
  "SubmissionReportId":"9dacddc7-9b39-485a-8c54-a19458ee21cf",
  "SupervisionReportId":"ad718221-5428-4a1f-8ea9-8c1e888a5091",
  "TimesheetReportId":"37ae68c5-7f01-4d6a-9715-1acb0a6680de",
  "VisitReportId":"3dacec28-94ee-4361-a652-e08801bfa754",
  "WorkHoursSummaryReportId":"da10b17f-25ed-40b5-ac8e-5e46ee656983",
  "clienthoursReportID":"593bb3d5-cd69-47ac-aba6-eddef4972e7c",
  "employeeLabels":"789ad0b4-5a59-4730-acc9-76c161afc1bd?",
  "inactiveclientReportID":"5ff23429-6093-401e-ae59-743b33bd1b53",
  "EmployeementServiceTimesheetReportId":"25de1d54-6f0c-4322-b119-9a516f98ffa4",
  "EmployeementServiceReportId":"070c0ab1-d879-4e90-9315-c269f05ddf98",
  "revenue":"019982e0-9be4-446a-afa9-e198c9f1b5e2",
  "EWEReportId": "99ce4a06-b4ba-4acd-97f5-503aa1582770",
  "Paylocity_PayrollReportId":"ead5d50c-595e-484c-85db-4c17a0831d5b",
  "DepositReportId":"c1db2a19-1329-4288-9316-ad2d35bf39bb",
  "PaymentsByPayerReportId":"aad9f995-89f8-46e6-a5ce-1d2be1a2e681",
  "DetailedRevenueClaimsReportId":"7b173c78-1290-48ba-9660-4f7d2ee60d55",
  "DetailedRevenueTimesheetReportId":"67dd65e6-f1c9-465a-9f79-d2ad21bc911e",
  "MonthEndData_byDate_ReportId":"336ba804-8856-4c19-b7fa-e9ba729769bb",
    "MonthEndData_byMonth_ReportId":"dee2545a-8086-4f37-8805-d396ba0e63d9",
    "MonthEndReportId":"51f587f4-b3e4-42f6-8100-572ea46776c0",
	"DetailedRevenueMonthEnd":"ecda9adb-59b4-4ab9-8fa4-2ee8ea5d4c6d",
      "APMServerURL": 'https://apmrum.allcaresoftware.com',
       "googleApiKey":"AIzaSyAOJA0XHRtR49T4Y4WNzEZXUouGoe9-XlI",
    "environment":"production",
  }
